/**
 * Integration for ZURB foundation core
 *
 * Imports and initializes foundation core
 *
 */

import $ from 'jquery';
import { Foundation } from 'foundation-sites/js/foundation.core';

Foundation.addToJquery($);

export { Foundation };
